export default __webpack_public_path__ + "static/media/rip_middle_ring.16f6949e.png";